import { LoginApiResponse, LoginResponse, mapLoginResponse } from '@/types/auth.types';
import axiosInstance from './axiosInstance';

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const { data } = await axiosInstance.post<LoginApiResponse>('/auth/login', {
      email: email.trim(),
      password,
    });
    return mapLoginResponse(data);
  }
};
